@if (loading) {
  <div class="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
@if (!loading) {
  <div class="contact-fields-container" [ngClass]="pageTitle !== PageTitle.SettingContactFields ? 'container' : ''">
    <div class="contact-fields-wrapper">
      @if (pageTitle !== PageTitle.SettingContactFieldsclass) {
        <h1>{{ "people.profileFields.titleProperties" | translate }}</h1>
      }
      <button mat-stroked-button class="primary-button" (click)="updatedContactField(null, true)">
        <mat-icon>add</mat-icon>
        <span>{{ "people.profileFields.addButton" | translate | uppercase }}</span>
      </button>
      <div class="contact-fields-table-component">
        @if (profileDataSource?.data.length > 0) {
          <div class="profile-table">
            <mat-table [dataSource]="profileDataSource">
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.name }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="mapTo">
                <mat-header-cell *matHeaderCellDef>Key</mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element">
                  <span>{{ element.mapTo | lowercase }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="options">
                <mat-header-cell [style.flex]="0.1" mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell
                  [style.flex]="0.1"
                  mat-cell
                  *matCellDef="let element"
                  class="options-column"
                  (click)="$event.stopPropagation()"
                  [matMenuTriggerFor]="!element.readonly ? contactFieldsOptionsMenu : null">
                  @if (!element.readonly) {
                    <i class="material-icons">more_vert</i>
                  }
                  <mat-menu #contactFieldsOptionsMenu="matMenu" class="contact-fields-menu">
                    <ng-container>
                      <button
                        mat-menu-item
                        deleteDialog
                        deletionType="{{ 'people.profileFields.titleProperties' | translate | lowercase }}"
                        deletionTypeText="{{ element.name }}"
                        deletionTypeHeader="{{ 'confirmationDialog.confirmationTitle' }}"
                        deletionText="{{ 'confirmationDialog.delete-message' }}"
                        (onDelete)="deleteContactField(element.id)"
                        class="delete-contact-fields-btn">
                        <div class="delete-contact-fields-icon">
                          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                          <span>{{ "generic.delete" | translate | uppercase }}</span>
                        </div>
                      </button>
                    </ng-container>
                    <ng-container>
                      <button mat-menu-item (click)="updatedContactField(element, false)" class="edit-contact-fields-btn">
                        <div class="edit-contact-fields-icon">
                          <mat-icon>edit</mat-icon>
                          <span>{{ "generic.edit" | translate | uppercase }}</span>
                        </div>
                      </button>
                    </ng-container>
                  </mat-menu>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row [ngClass]="row.readonly ? 'readonlyField' : ''" *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
          </div>
        }
      </div>
      <div class="contact-fields-hint">
        <p class="contact-fields-hint-title">{{ "people.profileFields.hint-usage.title" | translate }}</p>
        <ul>
          <li>
            {{ "people.profileFields.hint-usage.num1" | translate }}
            <span>(</span>
            <a href="{{ TRIGGERBEE_LINK_HELP['onsite-campaigns'] }}" target="kb">&nbsp;{{ "generic.readMore" | translate }}</a>
            <span>)</span>
          </li>
          <li>
            {{ "people.profileFields.hint-usage.num2" | translate }}
            <span>(</span>
            <a href="{{ TRIGGERBEE_LINK_HELP['contact-import'] }}" target="kb">&nbsp;{{ "generic.readMore" | translate }}</a>
            <span>)</span>
          </li>
          <li>
            {{ "people.profileFields.hint-usage.num3" | translate }}
            <span>(</span>
            <a href="{{ TRIGGERBEE_LINK_HELP['identity-visitor'] }}" target="kb">&nbsp;{{ "generic.readMore" | translate }}</a>
            <span>)</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
}
